<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FntSyT/tc-custom/9780226023946.jpg?1733091427572" alt="This image is the cover for the book Actual and the Rational"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Actual and the Rational
      </h1>
      <p class="bookDescription body article font2">
        <p>One of Hegel’s most controversial and confounding claims is that “the real is rational and the rational is real.” In this book, one of the world’s leading scholars of Hegel, Jean-François Kervégan, offers a thorough analysis and explanation of that claim, along the way delivering a compelling account of modern social, political, and ethical life.<br/><br/> ?Kervégan begins with Hegel’s term “objective spirit,” the public manifestation of our deepest commitments, the binding norms that shape our existence as subjects and agents. He examines objective spirit in three realms: the notion of right, the theory of society, and the state. In conversation with Tocqueville and other theorists of democracy, whether in the Anglophone world or in Europe, Kervégan shows how Hegel—often associated with grand metaphysical ideas—actually had a specific conception of civil society and the state. In Hegel’s view, public institutions represent the fulfillment of deep subjective needs—and in that sense, demonstrate that the real is the rational, because what surrounds us is the product of our collective mindedness. This groundbreaking analysis will guide the study of Hegel and nineteenth-century political thought for years to come.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jean-François Kervégan, Daniela Ginsburg, Martin Shuster
      </h2>
      
      <p class="authorDescription body article"><B>Jean-François Kervégan</B> is professor at the University Paris 1 Panthéon-Sorbonne. <B>Daniela Ginsburg</B> is a translator who has translated many articles and books in the humanities and social sciences. <B>Martin Shuster</B> is assistant professor and chair of Judaic studies in the Center for Geographies of Justice at Goucher College. He is the author of <I>New Television: The Aesthetics and Politics of a Genre</I>, also published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17105414